import {Component, effect, inject, input, OnInit} from '@angular/core';
import {ButtonComponent} from "@components";
import {CurrencyPipe} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CartService} from "../../services/cart.service";
import {RouterLink} from "@angular/router";
import {ArtworkCardComponent} from "../artwork/artwork-card/artwork-card.component";
import {AddressService} from "../../services/address-service";
import {AppService} from "@api-services";
import {LayoutService} from "@services";

export interface MBEResponse {
  success: boolean
  data: Data
}

export interface Data {
  destination: Destination
  insurance: Insurance
  items: Item[]
  mbeResponse: MbeResponse
}

export interface Destination {
  zipCode: string
  countryCode: string
}

export interface Insurance {
  value: string
  enabled: boolean
}

export interface Item {
  height: string
  length: string
  width: string
  weight: string
}

export interface MbeResponse {
  InternalReferenceID: string
  Status: string
  ShippingOptions: ShippingOptions
  CanSeePrices: boolean
}

export interface ShippingOptions {
  ShippingOption: ShippingOption[]
}

export interface ShippingOption {
  Service: string
  ServiceDesc: string
  CourierAccount: string
  Courier: string
  CourierDesc: string
  CourierService: string
  CourierServiceDesc: string
  NetShipmentPrice: string
  NetShipmentTotalPrice: string
  CODAvailable: boolean
  InsuranceAvailable: boolean
  IdSubzone: number
  CustomDuties: boolean
  SubzoneDesc: string
  MBESafeValueAvailable: boolean
  GrossShipmentPrice: string
  GrossShipmentTotalPrice: string
  MBESafeValue4BusinessAvailable: boolean
  isWW: boolean
  TargetService: boolean
}


@Component({
  selector: 'wun-cart',
  standalone: true,
  imports: [
    ButtonComponent,
    CurrencyPipe,
    ReactiveFormsModule,
    FormsModule,
    RouterLink,
    ArtworkCardComponent
  ],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss'
})
export class CartComponent {

  private readonly layoutService = inject(LayoutService);
  cartService = inject(CartService)
  addressService = inject(AddressService);

  showCheckoutButton = input(true)

  calculateShipping() {
    this.cartService.calculateShipping()
  }

  constructor() {

  }

  hideDrawer() {
    this.layoutService.hideCart();
  }
}
